var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Earn",
    transform: "translate(0.51 3.91)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_848",
    "data-name": "Group 848",
    transform: "translate(-8 -12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1965",
    "data-name": "Path 1965",
    d: "M121.867,116.54a5.273,5.273,0,1,1-5.257,5.273A5.265,5.265,0,0,1,121.867,116.54Z",
    transform: "translate(-102.339 -101.71)",
    fill: "#f3be0e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1966",
    "data-name": "Path 1966",
    d: "M12.373,20.1a7.147,7.147,0,1,0,7.147-7.147A7.155,7.155,0,0,0,12.373,20.1Zm7.147-6.373A6.373,6.373,0,1,1,13.145,20.1,6.381,6.381,0,0,1,19.519,13.727Zm.019-2.512a.387.387,0,0,0,.386-.387V8.477a.386.386,0,1,0-.773,0v2.351A.387.387,0,0,0,19.538,11.215Zm0,17.75a.387.387,0,0,0-.386.387V31.7a.386.386,0,1,0,.773,0V29.352A.387.387,0,0,0,19.538,28.965ZM31.1,19.7H28.759a.387.387,0,0,0,0,.774H31.1a.387.387,0,0,0,0-.774Zm-20.5.387a.387.387,0,0,0-.386-.387H7.876a.387.387,0,0,0,0,.774h2.344A.387.387,0,0,0,10.607,20.09ZM21.021,9.165a.387.387,0,0,0-.106.767A10.255,10.255,0,0,1,29.662,18.7a.386.386,0,1,0,.765-.106A11.029,11.029,0,0,0,21.021,9.165Zm-2.9,21.1A10.256,10.256,0,0,1,9.377,21.5a.386.386,0,1,0-.765.106,11.029,11.029,0,0,0,9.406,9.429.387.387,0,0,0,.105-.767ZM8.941,19.031a.386.386,0,0,0,.435-.331,10.255,10.255,0,0,1,8.747-8.768.387.387,0,0,0-.106-.767,11.029,11.029,0,0,0-9.406,9.429A.387.387,0,0,0,8.941,19.031ZM30.1,21.168a.386.386,0,0,0-.435.331,10.255,10.255,0,0,1-8.747,8.768.387.387,0,1,0,.105.767A11.029,11.029,0,0,0,30.427,21.6a.387.387,0,0,0-.33-.437Z",
    fill: "#f3be0e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rupee",
    d: "M203.45,181.864a.324.324,0,0,0,.324.324h2.215a1.219,1.219,0,0,1-1.181.892h-1.033a.327.327,0,0,0-.223.563l2.582,2.44a.325.325,0,1,0,.445-.473l-1.99-1.882h.218a1.857,1.857,0,0,0,1.325-.544,1.889,1.889,0,0,0,.52-1h.733a.324.324,0,1,0,0-.648h-.733a1.709,1.709,0,0,0-.429-.892h1.162a.324.324,0,1,0,0-.648h-3.611a.324.324,0,0,0,0,.648h1.033a1.209,1.209,0,0,1,1.181.892h-2.214A.324.324,0,0,0,203.45,181.864Z",
    transform: "translate(-186.052 -162.343)",
    fill: "#0f0f0f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarn);
export default __webpack_public_path__ + "static/media/Earn.47b342ec2a7c86ad83799edf5042bdbd.svg";
export { ForwardRef as ReactComponent };